module.exports = __webpack_public_path__ + "fonts/4442e12b56102fb6a25ee47745b5d80c.svg";